import React from "react";
import NewRelease from "../../components/new-release/new-release.js";
import useTitle from "../../hooks/useTitle.js";
import { isLoggedIn } from "../../utils/auth.js";
import { AUTH_SCREEN } from "../../utils/url.js";

export default function NewReleasepage() {
  useTitle("New Release");

  if (!isLoggedIn()) {
    window.location = '/';;
    return null;
  }

  return <NewRelease></NewRelease>;
}
